import React, { useState } from 'react';
import { AlertTriangleIcon } from 'lucide-react';
import { DetailModal } from './DetailModal';
interface AtRiskLoan {
  loName: string;
  fileNumber: string;
  slaBreach: string;
  borrower: string;
  subStatus: string;
  lastActivity: string;
}
interface PipelineStagnationProps {
  selectedLO: string;
}
const allAtRiskLoans: AtRiskLoan[] = [{
  loName: 'Sarah Chen',
  fileNumber: '#765432',
  slaBreach: '> 48 hrs',
  borrower: 'James Wilson',
  subStatus: 'App Out',
  lastActivity: '2 days ago'
}, {
  loName: 'Sarah Chen',
  fileNumber: '#765498',
  slaBreach: '> 24 hrs',
  borrower: 'Maria Lopez',
  subStatus: 'App Out',
  lastActivity: '1 day ago'
}, {
  loName: 'Michael Davis',
  fileNumber: '#789012',
  slaBreach: '> 72 hrs',
  borrower: 'Robert Taylor',
  subStatus: 'Docs Requested',
  lastActivity: '3 days ago'
}, {
  loName: 'Michael Davis',
  fileNumber: '#789045',
  slaBreach: '> 48 hrs',
  borrower: 'Linda Brown',
  subStatus: 'App Out',
  lastActivity: '2 days ago'
}, {
  loName: 'Chrao Dunon',
  fileNumber: '#765376',
  slaBreach: '> 48 hrs',
  borrower: 'David Martinez',
  subStatus: 'Disclosure Sent',
  lastActivity: '2 days ago'
}, {
  loName: 'Alex Kim',
  fileNumber: '#765432',
  slaBreach: '> 48 hrs',
  borrower: 'Jennifer Lee',
  subStatus: 'App Out',
  lastActivity: '2 days ago'
}, {
  loName: 'Alex Kim',
  fileNumber: '#765501',
  slaBreach: '> 48 hrs',
  borrower: 'Thomas Anderson',
  subStatus: 'Docs Requested',
  lastActivity: '2 days ago'
}, {
  loName: 'Priya Patel',
  fileNumber: '#765306',
  slaBreach: '> 72 hrs',
  borrower: 'Susan Clark',
  subStatus: 'App Out',
  lastActivity: '3 days ago'
}];
function getAtRiskByLO(loans: AtRiskLoan[]) {
  const counts: Record<string, number> = {};
  loans.forEach(loan => {
    counts[loan.loName] = (counts[loan.loName] || 0) + 1;
  });
  return Object.entries(counts).map(([name, count]) => ({
    name,
    count
  })).sort((a, b) => b.count - a.count);
}
const LO_COLORS = ['bg-orange-500', 'bg-red-500', 'bg-amber-500', 'bg-rose-400', 'bg-orange-400', 'bg-red-400', 'bg-amber-400'];
const modalColumns = [{
  key: 'fileNumber',
  label: 'File #'
}, {
  key: 'borrower',
  label: 'Borrower'
}, {
  key: 'subStatus',
  label: 'Sub-Status'
}, {
  key: 'slaBreach',
  label: 'SLA Breach',
  render: (value: string) => <span className="inline-flex items-center gap-1 text-orange-600 font-medium" data-id="element-70">
        <AlertTriangleIcon className="w-3.5 h-3.5" data-id="element-71" />
        {value}
      </span>
}, {
  key: 'lastActivity',
  label: 'Last Activity'
}];
export function PipelineStagnation({
  selectedLO
}: PipelineStagnationProps) {
  const [modalLO, setModalLO] = useState<string | null>(null);
  const filteredLoans = selectedLO === 'all' ? allAtRiskLoans : allAtRiskLoans.filter(loan => loan.loName === selectedLO);
  const atRiskByLO = getAtRiskByLO(filteredLoans);
  const maxCount = atRiskByLO.length > 0 ? Math.max(...atRiskByLO.map(lo => lo.count)) : 1;
  const modalData = modalLO ? filteredLoans.filter(loan => loan.loName === modalLO) : [];
  return <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-72">
      <div className="flex items-center justify-between mb-6" data-id="element-73">
        <h2 className="text-xl font-bold text-gray-900" data-id="element-74">PIPELINE STAGNATION</h2>
        <span className="text-sm font-medium text-gray-600" data-id="element-75">
          {filteredLoans.length} At-Risk Loan
          {filteredLoans.length !== 1 ? 's' : ''}
        </span>
      </div>

      {filteredLoans.length === 0 ? <div className="py-12 text-center" data-id="element-76">
          <p className="text-sm text-gray-500" data-id="element-77">
            No at-risk loans for this loan officer.
          </p>
        </div> : <div className="space-y-3" data-id="element-78">
          {filteredLoans.map((loan, index) => <button key={index} onClick={() => setModalLO(loan.loName)} className="w-full flex items-center justify-between p-4 bg-gray-50 rounded-lg border border-gray-200 hover:border-blue-300 hover:bg-blue-50/30 transition-colors cursor-pointer text-left" data-id="element-79">
              <div className="flex items-center gap-4 flex-1" data-id="element-80">
                <div className="flex-1" data-id="element-81">
                  <p className="text-sm font-medium text-gray-900" data-id="element-82">
                    LO: {loan.loName}
                  </p>
                </div>
                <div className="flex-1" data-id="element-83">
                  <p className="text-sm text-gray-600" data-id="element-84">
                    File {loan.fileNumber}
                  </p>
                </div>
              </div>

              <div className="flex items-center gap-3" data-id="element-85">
                <span className="px-3 py-1 bg-orange-100 text-orange-800 text-xs font-semibold rounded-full" data-id="element-86">
                  [At Risk]
                </span>
                <div className="flex items-center gap-1.5 text-orange-600" data-id="element-87">
                  <AlertTriangleIcon className="w-4 h-4" data-id="element-88" />
                  <span className="text-xs font-medium" data-id="element-89">
                    SLA Breach {loan.slaBreach}
                  </span>
                </div>
              </div>
            </button>)}
        </div>}

      {atRiskByLO.length > 0 && <div className="mt-6 pt-4 border-t border-gray-200" data-id="element-90">
          <h3 className="text-sm font-semibold text-gray-700 mb-4" data-id="element-91">
            At-Risk Loans by Loan Officer
          </h3>
          <div className="space-y-3" data-id="element-92">
            {atRiskByLO.map((lo, index) => {
          const widthPercent = lo.count / maxCount * 100;
          return <button key={lo.name} onClick={() => setModalLO(lo.name)} className="w-full flex items-center gap-3 group cursor-pointer" data-id="element-93">
                  <span className="text-sm font-medium text-gray-700 w-32 truncate shrink-0 text-left group-hover:text-blue-600 transition-colors" data-id="element-94">
                    {lo.name}
                  </span>
                  <div className="flex-1 h-7 bg-gray-100 rounded-full overflow-hidden relative group-hover:bg-gray-200 transition-colors" data-id="element-95">
                    <div className={`h-full ${LO_COLORS[index % LO_COLORS.length]} rounded-full transition-all duration-500 ease-out flex items-center justify-end pr-2 group-hover:brightness-110`} style={{
                width: `${Math.max(widthPercent, 12)}%`
              }} data-id="element-96">
                      <span className="text-xs font-bold text-white" data-id="element-97">
                        {lo.count}
                      </span>
                    </div>
                  </div>
                </button>;
        })}
          </div>
        </div>}

      <DetailModal isOpen={modalLO !== null} onClose={() => setModalLO(null)} title={`At-Risk Loans — ${modalLO}`} subtitle={`${modalData.length} loan${modalData.length !== 1 ? 's' : ''} with active SLA breaches`} columns={modalColumns} data={modalData} data-id="element-98" />
    </div>;
}